import React, {Component} from 'react';
import styled from 'react-emotion';
import qs from 'qs';
import {Input, Form, Select, Button, Responsive} from 'semantic-ui-react';
import {withRouter} from 'react-router';

import RequiresRole, {ROLES} from '../security/RequiresRole';
import {SEARCH_KEYS, SEARCH_HEADERS, SEARCH_KEY_HEADERS} from '../../constants';

const FormWrapper = styled(Form)`
  &.ui.form {
    margin-bottom: 0;
    @media (max-width: 850px) {
      flex-direction: column-reverse;
      display: flex;
    }

    .inline.fields {
      margin-bottom: 0;

      .field {
        display: flex;
      }
    }

    .field {
      .ui.button {
        background: #dfae38;
        color: #fff;
        border-radius: 30px !important;
        margin-top: 10px;
      }
      .ui.input.search {
        padding: 3px;
        background: #fff;
        border: solid 1px rgba(0, 0, 0, 0.2);
        border-radius: 30px;

        input {
          border: none;
          border-radius: 30px;
        }

        .ui.selection.dropdown {
          border: none;
          box-shadow: none;
        }

        .visible.menu {
          border: none;
        }

        .ui.button {
          margin-left: 10px;
          margin-top: 0;
        }
      }
    }

    label,
    .inline.fields > label {
      font-size: 0.8rem;
      text-transform: uppercase;
      color: #888;

      @media (max-width: 400px) {
        font-size: 0.7rem;
      }
    }

    .ui.input.search {
      .ui.dropdown {
        display: inline-flex;
        font-size: 13px;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px !important;
        padding-top: 0px;
        padding-bottom: 0px;
        align-items: center;
        margin-top: 4px;
      }
    }

    .ui.action.input:not([class*='left action']) > input {
      margin-right: 2px;
      border-top-right-radius: 15px !important;
      border-bottom-right-radius: 15px !important;
    }
  }

  .search-type-selector .text {
    position: relative;
    top: -2px;
  }
`;

const options = [
  {text: SEARCH_HEADERS.SERIAL_NUMBER, value: SEARCH_KEYS.SERIAL_NUMBER},
  {text: SEARCH_HEADERS.PART_NUMBER, value: SEARCH_KEYS.PART_NUMBER},
  {text: SEARCH_HEADERS.PO_NUMBER, value: SEARCH_KEYS.PO_NUMBER},
];

class DocumentationSearchForm extends Component {
  state = {
    searchKey:
      qs.parse(this.props.location.search.substr(1)).key || 'serial-number',
  };

  _handleChange = (e, {value}) => {
    this.setState({searchKey: value});
  };

  _handleSave = e => {
    const params = {
      query: e.target.search.value,
      key: this.state.searchKey,
    };

    if (e.target.search.value.length < 3) {
      alert('Search term must be at least 3 characters');
    } else {
      this.props.history.push(
        `/product-documentation/search?${qs.stringify(params)}`
      );
      e.target.reset();
    }
  };

  render() {
    const searchHeader = SEARCH_KEY_HEADERS[this.state.searchKey] || '';
    return (
      <FormWrapper onSubmit={this._handleSave}>
        <Responsive minWidth={765}>
          <Form.Field>
            <Input
              type="text"
              name="search"
              placeholder={`Search By ${searchHeader}`}
              action
              className="search"
            >
              <input />
              <RequiresRole
                roles={[
                  ROLES.CUSTOMER_ADMIN,
                  ROLES.CUSTOMER_USER,
                  ROLES.SYSTEM_ADMIN,
                  ROLES.MM_ADMIN,
                ]}
              >
                <Select
                  className="search-type-selector"
                  compact
                  options={options}
                  value={this.state.searchKey}
                  onChange={this._handleChange}
                />
              </RequiresRole>
              <Button type="submit">Search</Button>
            </Input>
          </Form.Field>
        </Responsive>
        <Responsive maxWidth={764}>
          <Form.Field>
            <Input
              type="text"
              name="search"
              placeholder="Search"
              action
              className="search mobile-search"
              size="mini"
            >
              <RequiresRole
                roles={[
                  ROLES.CUSTOMER_ADMIN,
                  ROLES.CUSTOMER_USER,
                  ROLES.SYSTEM_ADMIN,
                  ROLES.MM_ADMIN,
                ]}
              >
                <Select
                  className="search-type-selector"
                  compact
                  options={options}
                  value={this.state.searchKey}
                  onChange={this._handleChange}
                />
              </RequiresRole>
              <input />
            </Input>
            <Button type="submit">Search</Button>
          </Form.Field>
        </Responsive>
      </FormWrapper>
    );
  }
}

export default withRouter(DocumentationSearchForm);
